import {
  CommMessage,
  IEvents,
  INCOMING_EVENTS,
  OEvents,
  OUTGOING_EVENTS,
} from "./models";

const targetWindow = window.parent;

export class HostWindowCommService {
  static instance: HostWindowCommService;
  parent_window: Window;
  ievent_fn_map: Map<string, (event: any) => void>;
  initMessageListeners: () => void;

  constructor() {
    this.parent_window = targetWindow;
    this.ievent_fn_map = new Map();
    this.initMessageListeners = () => {
      window.addEventListener(
        "message",
        (event) => {
          // Only trust messages from the loader. For the primary instance
          // that's simply window.parent (targetWindow). For the PiP copy,
          // window.parent is the Document PiP window itself (pipWindow) —
          // but the loader's GetAChatBotFrame instance runs entirely in
          // the ORIGINAL top-level page, not inside pipWindow, and sends
          // messages via `pipIframe.contentWindow.postMessage(...)`
          // directly from there. Per the postMessage spec, event.source
          // is the window that CALLED postMessage, not this iframe's own
          // containment hierarchy — so every message the loader sends
          // into the PiP copy (including the CHATBOT_START that boots
          // the whole app) arrives with event.source set to that original
          // top-level page, not to pipWindow/targetWindow. A Document PiP
          // window's opener is that same original page (it behaves like
          // a same-origin window.open() popup), so also accept messages
          // from targetWindow.opener to cover this case. Without this
          // guard entirely, any other frame the host page can reach (an
          // ad iframe, a sibling widget) could inject arbitrary chat
          // messages or trigger SmartAI queries in this visitor's session.
          if (
            event.source !== targetWindow &&
            event.source !== (targetWindow as any)?.opener
          ) {
            return;
          }
          if (event.data.hasOwnProperty("event_type")) {
            const event_name = event.data.event_type;
            if (INCOMING_EVENTS.has(event_name)) {
              if (this.ievent_fn_map.has(event_name)) {
                const callback = this.ievent_fn_map.get(event_name);
                callback && callback(event);
              }
            }
          }
        },
        false
      );
    };
    this.initMessageListeners();
  }
  registerEventListener(
    event_name: IEvents,
    event_callback: (event: any) => void
  ) {
    if (INCOMING_EVENTS.has(event_name)) {
      this.ievent_fn_map.set(event_name, event_callback);
    } else {
      throw new Error("IEvent Type not available!");
    }
  }

  postMessage(message: CommMessage) {
    if (this.parent_window) {
      if (OUTGOING_EVENTS.has(message.event_type as OEvents)) {
        this.parent_window.postMessage(message, "*");
      } else {
        throw new Error("OEvent Type not available!");
      }
    } else {
      throw new Error("Parent Window not available!");
    }
  }

  static getInstance() {
    if (!HostWindowCommService.instance) {
      HostWindowCommService.instance = new HostWindowCommService();
    }
    return HostWindowCommService.instance;
  }
}
